// @flow
import classnames from 'classnames';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

// $FlowFixMe
export const getBadge = (backends, backendUrl_) => {
  let backendUrl = backendUrl_ || localStorage.getItem('avaBackendUrl');
  let name;
  let backgroundColor;

  switch (backendUrl) {
    case 'https://scribe-playground.ava.me':
    case 'https://api-stage.ava.me':
    case 'stage':
      name = 'stage';
      backgroundColor = 'steelblue';
      break;
    case 'production':
    case 'https://scribe.ava.me':
    case 'https://backend.ava.me':
    case undefined:
    case null:
      name = 'production';
      backgroundColor = 'seagreen';
      break;
    default:
      name = backendUrl;
      backgroundColor = 'saddlebrown';
      break;
  }
  if (backendUrl && backends[backendUrl] && backends[backendUrl].color) {
    backgroundColor = `#${backends[backendUrl].color}`;
    ({ name } = backends[backendUrl]);
  }
  return {
    name,
    backgroundColor,
  };
};

const useStyles = makeStyles(() => ({
  wrapper: {
    marginLeft: '3px',
    marginRight: '3px',
    paddingLeft: '6px',
    WebkitAppRegion: 'no-drag',
    borderRadius: '3px',
    paddingRight: '6px',
    paddingTop: '1px',
    paddingBottom: '2px',
  },
}));

interface Props {
  children: any;
  className?: string;
  style?: Object;
}

// @flow
export const BackendBadge = ({ children, className, style }: Props) => {
  const classes = useStyles();

  return (
    <div className={classnames(classes.wrapper, className)} style={style}>
      {children}
    </div>
  );
};
